import React from 'react';

import ActivityDropdown from '../../base/dropdowns/activity-dropdown';

const RetailersDropdown = ({ retailerOptions, filterBy, setFilterBy, type }) => {
  return (
    <div className={type === 'new-partner-admin' ? 'new-retailers-dropdown' : 'retailers-dropdown'}>
      <ActivityDropdown
        items={retailerOptions}
        selectItem={idx => setFilterBy(retailerOptions[idx])}
        dropdownLabel={filterBy.label}
        initialSelection={retailerOptions.findIndex(item => item.label === filterBy.label)}
      />
    </div>
  );
};

export default RetailersDropdown;
